
export type GeneratorType = 'QUERY' | 'JASPER' | 'CRYSTAL_REPORTS' | 'BE_EFFICIENT_REPORT' | 'SCRIPT';
export const GeneratorTypeValues: GeneratorType[] = ['QUERY' , 'JASPER' , 'CRYSTAL_REPORTS' , 'BE_EFFICIENT_REPORT' , 'SCRIPT'];

export interface IReportDefinition {
  createdAt: any;
  cronExpression: string;
  generationSettings: IReportDefinition$IReportGenerationSettings;
  group: string;
  id: number;
  name: string;
  outputSettings: IReportDefinition$IReportOutput;
  parameters: IReportDefinition$IReportParameter[];
  updatedAt: any;
}

export interface IReportDefinition$IReportGenerationSettings {
  beEfficientReportName: string;
  beEfficientReportsOutputFilename: string;
  crystalReportsFile: string;
  crystalReportsOutputFilename: string;
  jasperDoNotGenerateIfNoPages: boolean;
  jasperFile: string;
  jasperOutputFilename: string;
  queries: IReportDefinition$IReportGenerationSettings$IQuery[];
  queriesDoNotGenerateXlsxIfNoResults: boolean;
  queriesFileName: string;
  scriptSource: string;
  type: GeneratorType;
}

export interface IReportDefinition$IReportGenerationSettings$IQuery {
  enableFilters: boolean;
  name: string;
  src: string;
}

export interface IReportDefinition$IReportOutput {
  emailDoNotSendIfNoFiles: boolean;
  emailSubject: string;
  emailSubjectIfNoFiles: string;
  emailText: string;
  emailTextIfNoFiles: string;
  printerId: number;
  scriptSource: string;
  targetCcEmailAddresses: string;
  targetEmailAddresses: string;
  targetFolder: string;
  type: OutputType;
}

export interface IReportDefinition$IReportParameter {
  askOnRun: boolean;
  format: string;
  name: string;
  type: string;
  value: string;
}

export type OutputType = 'NONE' | 'EMAIL' | 'DISK' | 'PRINTER' | 'SCRIPT';
export const OutputTypeValues: OutputType[] = ['NONE' , 'EMAIL' , 'DISK' , 'PRINTER' , 'SCRIPT'];

